import React, { useContext, useState, useEffect, useRef } from "react";
import "../../styles/preparepdf.css";

import { ShareContext } from "../../context/ShareContext";

import { useNavigate, useLocation, Link } from "react-router-dom";
import * as Constants from "../../constants";

import BackLoader from "../backloader";
import Seal from "../../assets/seal.png";
import Sign2 from "../../assets/sign.png";
import { Button } from "@mui/material";
import JisPrompt from "../jisprompt";
import JisAlert from "../jisalert";

import { green, red } from "@mui/material/colors";
import moment from "moment";
import DynamicIcon from "../dynamicicon";
import JisButton from "../controls/jisButton";
import JisDialog from "../dialog";
import JisDialogForm from "../formdialog";
import JisInternalPay from "./internal_pay";
import { CirclePlus, EditIcon, Trash2 } from "lucide-react";

function LegalCounselorJisPrepareTemplate({
  templatedoc,
  docInfo,
  isLegal = true,
  doctype = "document",
  autoFill = [],
  onDone,
  isCfo,
  isPaid,
  scheduleButtonText,
  onSchedule,
  isCurrentDocCommissioned,
}) {
  const {
    isThirdOpt,
    setWhichUpload,
    token,
    frequentData,
    setIsExpired,
    profile,
  } = useContext(ShareContext);

  var item = docInfo;

  console.log(docInfo, "docInfo");
  console.log(templatedoc, "templatedoc");

  const urlSaveInst = `${Constants.apiUrl}/filing/uploadtemplate`;
  const urlInstrument = `${Constants.apiUrl}/filing/instrument`;
  const [html, setHtml] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const amount = searchParams.get("amount");
  const sealAmt=searchParams.get("seal");
  const ref = searchParams.get("ref");

  const [holders, setHolders] = useState([]);
  const [holdervalues, setHolderValues] = useState({});
  const [presentTag, setPresentTag] = useState(new Set());
  const [upload, setUpload] = useState({ open: false, title: "", id: 0 });

  const pattern = /\[.+?\]/g;

  const affidavit_search_prefix = "LSJ/HC/AFF";
  const [cfoWarn, setCfoWarn] = useState(false);
  const [isDialog, setIsDialog] = useState(false);
  const [doc, setDocument] = useState({ uplines: [], uplinesigns: [] });
  const [currectdoc, setCurrentDoc] = useState(templatedoc);
  const [uplineIndex, setUplineIndex] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const [seal, setSeal] = useState("");
  const [passport, setPassport] = useState("");
  const [sign, setSign] = useState("");
  const [initial, setInitial] = useState("");
  const [stamp, setStamp] = useState("");
  const [fAutoFill, setfAutoFill] = useState(autoFill);
  const [permissionList, setDocPermissionList] = useState(new Set());

  const [posId, setPosId] = useState(0);
  const [dstart, setDStart] = useState({ isDragging: false });
  const [imgs, setImgs] = useState([]);
  const [activeFile, setActiveFile] = useState({});
  const [isSaved, setIsSaved] = useState(true);
  const [allDocCompleted, setAllDocCompleted] = useState(false);
  const [activeSub, setActiveSub] = useState({ open: false });
  const [refresh, setRefresh] = useState(false);
  const prevHolderValuesRef = useRef({});
  const isSwitchingTemplateRef = useRef(false);
  const [isPay, setIsPay] = useState(false);
  const [isCFOPassportApplied, setIsCFOPassportApplied] = useState(false);
  const [isTextareaFilled, setIsTextareaFilled] = useState(false);

  const needpermission = "Affidavit saved successfully";
  const noneedpermission =
    "Document saved successfully! Wait for the CFO to initial your document";
  const finalmsgcase = `You have worked on all document(s), the case will now move to Process Section Assessors' Queue `;
  const finalmsgaffidavit =
    "You have worked on the affidavit. The process is completed now";
  const finalmssheriff = `Document processed successfully! You have worked on Service Sheriff affidavit. `;
  const finalsettlement = `Term of settlement processed successfully! `;

  const onSaveInst = () => {
    if (!upload.isImage) return;
    onUploadIns();
  };

  const [imgPrev, setImgPrev] = useState({ data: "", type: "", open: false });
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "" });
  const [prompt, setPrompt] = useState({
    open: false,
    title: "",
    subtitle: "",
    isImage: false,
  });

  const navigate = useNavigate();

  const onOk = () => {
    console.log("working here");
    setAlert({ ...alert, open: false });
  };

  const onOk_Save = () => {
    setAlert({ ...alert, open: false });
    if (item.type == "affidavit") {
      navigate("/affidavits");
    }
    if (item.type == "sheriff") {
      navigate("/cfo-e-swearing-sheriff");
    }

    if (typeof onDone === "function") {
      onDone(currectdoc);
    }
  };

  const onCancel = () => {};

  const confirmCaseDoc = () => {
    navigate("/upload/documents");
    setWhichUpload("Third");
  };

  useEffect(() => {
    if (!(autoFill == null || autoFill.length == 0)) {
      setfAutoFill(autoFill);
    }
  }, [autoFill]);

  useEffect(() => {
    // Save current values before switching so we can carry them over to the new template
    prevHolderValuesRef.current = holdervalues;
    isSwitchingTemplateRef.current = Object.keys(holdervalues).length > 0;

    setCurrentDoc(templatedoc);

    onLoadPermissions();
    onLoadInstrument();
    var temp = templatedoc.template;
    var htmlstr = Constants.b64decode(temp?.html);
    setHtml(htmlstr);

    if (templatedoc.upline.templateJson != null) {
      const jsonstr = atob(templatedoc.upline.templateJson);
      const jsobj = JSON.parse(jsonstr);
      setHolderValues(jsobj);
      isSwitchingTemplateRef.current = false; // already has saved values, no need to remap
      setIsSaved(true);
    } else {
      setHolderValues({});
      setIsSaved(false);
    }
    const tags = Array.from(htmlstr.match(pattern));
    setPresentTag(new Set(tags));
    onTemplateHolder(temp.id);
  }, [templatedoc]);

  // When new holders load after a template switch, remap previous input values by matching placeholder tags
  useEffect(() => {
    if (!isSwitchingTemplateRef.current || holders.length === 0) return;
    const prevValues = prevHolderValuesRef.current;
    if (Object.keys(prevValues).length === 0) return;

    isSwitchingTemplateRef.current = false;

    // Build a lookup of placeholder tag → old value entry
    const prevByTag = {};
    Object.values(prevValues).forEach((v) => {
      if (v?.holder) prevByTag[v.holder] = v;
    });

    // Map old values to new holder IDs
    const newHv = {};
    holders.forEach((h) => {
      const match = prevByTag[h.holder];
      if (match) {
        newHv[h.id] = { ...h, value: match.value, type: match.type, listobj: match.listobj };
      }
    });

    if (Object.keys(newHv).length > 0) {
      setHolderValues(newHv);
      setIsSaved(false);
    }
  }, [holders]);

  const onLoadPermissions = async () => {
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/setup/gazette-lines-permission`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      if (data.code == 0) {
        setDocPermissionList(new Set(data.ids));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onTemplateHolder = async (tempid) => {
    const temprl = `${Constants.apiUrl}/filing/templates/${tempid}/holders`;
    try {
      setIsLoading(true);
      const resp = await fetch(temprl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      if (data.code == 0) {
        setHolders(data.holders);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const previewImage = async (event) => {
    const input = event.target;
    if (input.files && input.files[0]) {
      var b64 = await Constants.toBase64(input.files[0]);
      setUpload({ ...upload, isImage: true, data: b64, file: input.files[0] });
    }
  };

  const onUploadIns = async () => {
    setIsLoading(true);
    var ext = upload.file.name?.split(".")[1];
    var rdata = {
      base64: upload.data?.split(",")[1],
      ext,
      holderId: upload.id,
    };

    fetch(urlSaveInst, {
      method: "POST",
      body: JSON.stringify(rdata),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          var hv = { ...holdervalues };
          var row = hv[upload.id];
          const filename = `${Constants.docUrl}holdermedia/${data.filename}`;
          if (row == null) {
            hv[upload.id] = {
              ...upload.holder,
              value: filename,
              type: "media",
            };
          } else {
            hv[upload.id] = { ...row, value: filename };
          }

          setHolderValues(hv);
          setUpload({ open: false });
          replaceTemplate(hv);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const onAppendOnServer = async () => {
    setIsLoading(true);
    const url = `${Constants.apiUrl}/filing/appendInstrument/${currectdoc?.upline?.id}`;
    var ll = [];
    for (const x of imgs) {
      var l = { InstrumentType: x.instype, x: x.x, y: x.y };
      ll.push(l);
    }

    fetch(url, {
      method: "POST",
      body: JSON.stringify(ll),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          setImgPrev({ ...imgPrev, open: false });
          setAlert({
            ...alert,
            title: imgPrev.type,
            open: true,
            subtitle: `Saved Append Successfully`,
            onOk: onOk_Save(),
          });
          setPrompt({ ...prompt, open: false });
          onSetImg(data.instPath, imgPrev.type);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const onSetImg = (path, type) => {
    const ct = type.toLowerCase();
    if (ct == "seal") {
      setSeal(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "passport") {
      setPassport(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "signature") {
      setSign(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "initial") {
      setInitial(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "stamp") {
      setStamp(`${Constants.docUrl}instrument/${path}`);
    }
  };

  const onLoadInstrument = async () => {
    try {
      setIsLoading(true);
      const resp = await fetch(urlInstrument, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      if (data.code == 0) {
        for (const x of data.inst) {
          onSetImg(x.instPath, x.instrument);
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onAddList = (holder) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    if (row.listobj == null) {
      row.listobj = [];
    }
    hv[holder.id] = { ...row, listobj: [...row.listobj, row.value], value: "" };
    setHolderValues(hv);
    replaceTemplate(hv);
  };

  const onRemoveList = (holder, idx) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    var list = row.listobj;
    list.splice(idx, 1);
    hv[holder.id] = { ...row, listobj: [...list], value: "" };
    setHolderValues(hv);
    replaceTemplate(hv);
  };

  const onEditList = (holder, idx) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    var list = row.listobj;
    hv[holder.id] = { ...row, value: list[idx].value, editindex: idx };
    setHolderValues(hv);
    replaceTemplate(hv);
  };

  const onAddPara = (holder) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    if (row.editindex == null) {
      if (row.listobj == null) {
        row.listobj = [];
      }
      const ovalue = { value: row.value, sub: [] };
      hv[holder.id] = { ...row, listobj: [...row.listobj, ovalue], value: "" };
    } else {
      row.listobj[row.editindex] = {
        ...row.listobj[row.editindex],
        value: row.value,
      };
      hv[holder.id] = { ...row, value: "", editindex: null };
    }

    setHolderValues(hv);
    replaceTemplate(hv);
  };

  const onAddSubPara = () => {
    const idx = activeSub.idx;
    var hv = { ...holdervalues };
    var row = hv[activeSub.holder.id];
    var list = row.listobj;
    var li = list[idx];

    if (li.subs == null) {
      li.subs = [activeSub.value];
    } else {
      li.subs = [...li.subs, activeSub.value];
    }
    list[idx] = { ...li, subs: li.subs };
    row = { ...row, listobj: list };

    hv[activeSub.holder.id] = { ...row };
    setHolderValues(hv);
    setActiveSub({ open: false });
    replaceTemplate(hv);
  };

  const onRemoveSubList = (holder, idx, idxx) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    var list = row.listobj;
    var li = list[idx];

    li.subs.splice(idxx, 1);
    list[idx] = { ...li, subs: li.subs };
    row = { ...row, listobj: list };

    hv[holder.id] = { ...row };

    setHolderValues(hv);
    replaceTemplate(hv);
  };

  const onAppending = (holder) => {
    if (
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-DEPONENT]" ||
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-COMISSIONER]"
    ) {
      if (
        (permissionList.has(currectdoc?.upline?.gazetteItemId) ||
          item.type == "affidavit") &&
        !currectdoc?.upline?.allowSign
      ) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Append ",
          subtitle:
            "Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call",
          onOk,
        });
        return;
      }
    }

    setUpload({
      open: true,
      title: holder.name,
      id: holder.id,
      holder,
      isImage: false,
    });
  };

  const returnTag = (holder, ind) => {
    var hv = { ...holdervalues };

    const m = fAutoFill?.find((d) => d.holder === holder.holder);
    if (m) {
      if (hv[holder.id] == null) {
        hv[holder.id] = { ...holder, value: m.value, type: "single" };
        setHolderValues(hv);
        replaceTemplate(hv);
      }
    } else if (holder.holder == "[DIVISION]" && item?.division != null) {
      if (hv[holder.id] == null) {
        hv[holder.id] = { ...holder, value: item.division, type: "single" };
        setHolderValues(hv);
        replaceTemplate(hv);
      }
    } else if (holder.holder == "[SUIT_NO]" && item?.caseNumber != null) {
      var row = hv[holder.id];
      if (hv[holder.id] == null) {
        hv[holder.id] = { ...holder, value: item.caseNumber, type: "single" };
        setHolderValues(hv);
        replaceTemplate(hv);
      }
    } else if (holder.dataType == "TEXT[NORMAL]") {
      return (
        <div className="input-create">
          <label htmlFor="doc-title">{holder.name} </label>
          <input
            type="text"
            placeholder={holder.hint}
            value={onGetValue(holder)}
            onChange={(e) => onDirectText(e, holder)}
            required
          />
        </div>
      );
    } else if (holder.dataType == "TEXT[MULTIPLE-INPUT]") {
      return (
        <div className="input-create">
          <label htmlFor="defendant">{holder.name}</label>
          <div className="btn-input">
            <input
              type="text"
              placeholder={holder.hint}
              value={onGetValue(holder)}
              onChange={(e) => onDirectTextMultiple(e, holder, ind)}
              required
            />
            <button type="button" onClick={() => onAddList(holder)}>
              Add <DynamicIcon iname="plus_circle" />
            </button>
          </div>
          <ul className="temp">
            {hv[holder.id] != null &&
              hv[holder.id].listobj?.map((li, idx) => {
                return (
                  <li key={idx}>
                    <div className="content">{li}</div>
                    <div className="action">
                      <div
                        className="icon"
                        onClick={() => onRemoveList(holder, idx)}
                      >
                        <DynamicIcon iname="close" />
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      );
    } else if (
      holder.dataType == "CFO-DATE" ||
      holder.dataType == "[CFO-DATE]" ||
      holder.dataType == "[COUNSEL-DATE]" ||
      holder.dataType == "COUNSEL-DATE" ||
      holder.dataType == "[DATE]"
    ) {
      return (
        <div className="input-create">
          <label htmlFor="doc-title">{holder.name}</label>
          <input
            type="date"
            placeholder={holder.hint}
            value={onGetValue(ind)}
            onChange={(e) => onDirectText(e, holder)}
            required
          />
        </div>
      );
    } else if (
      holder.dataType == "[CFO-DATE-TIME-STAMP]" ||
      holder.dataType == "CFO-DATE-TIME-STAMP" ||
      holder.dataType == "[DATE-TIME-STAMP]"
    ) {
      return (
        <div className="append">
          <label htmlFor="doc-title" style={{ fontWeight: "bold" }}>
            {holder.name}{" "}
          </label>
          <button
            onClick={() => onTimeStamp(holder)}
            className="append_timestamp"
            type="button"
          >
            Append Timestamp
          </button>
        </div>
      );
    } else if (
      holder.dataType == "TEXT[LEGAL-COUNSEL-CONTACT]" ||
      holder.dataType == "TEXT[DETAIL-AND-SERVICE-ADDRESS-SECTION]"
    ) {
      return (
        <div className="input-create">
          <label htmlFor="doc-title">{holder.name} </label>
          <textarea
            id="paragraph"
            placeholder={holder.hint}
            value={onGetValue(holder)}
            onChange={(e) => onDirectText(e, holder)}
            required
          ></textarea>
        </div>
      );
    } else if (holder.dataType == "TEXT[MULTIPLE-TEXTAREA]") {
      return (
        <div className="input-create">
          <label
            style={{
              textTransform: "capitalize",
            }}
            htmlFor="paragraph"
          >
            {holder.name}
          </label>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              position: "relative",
              backgroundColor: "#ffffff",
              marginBottom: "12px",
              marginTop: "8px",
            }}
          >
            <textarea
              style={{
                width: "100%",
                height: "64px",
                maxHeight: "64px",
                resize: "none",
                border: "1px solid #C8CACE",
                borderRadius: "8px",
                padding: "14px 35px 14px 14px",
              }}
              id="paragraph"
              placeholder={holder.hint}
              value={onGetValue(holder)}
              onChange={(e) => onDirectAreaMultiple(e, holder, ind)}
            ></textarea>
            <button
              className="add_btn_combo"
              onClick={() => onAddPara(holder)}
              type="button"
            >
              {Constants.IsNull(holdervalues[holder.id]?.editindex)
                ? "Add"
                : "Update"}
            </button>
          </div>
          <ul className="temp">
            {hv[holder.id] != null &&
              hv[holder.id].listobj?.map((li, idx) => {
                return (
                  <li
                    style={{
                      marginBlock: "10px",
                      display: "flex",
                      alignItems: "top",
                      justifyContent: "space-between",
                      position: "relative",
                      flexDirection: "column",
                      gap: "16px",
                    }}
                    key={idx}
                  >
                    <div className="content">
                      {li.value}
                      <div style={{ marginLeft: 16, marginRight: 16 }}>
                        {li.subs != null &&
                          li.subs?.map((sub, idxx) => {
                            return (
                              <div
                                key={idxx}
                                style={{ backgroundColor: "#ccc" }}
                              >
                                <div className="content">
                                  {Constants.getAlphaByNum(idxx + 1)}). {sub}
                                </div>
                                <div className="action">
                                  <div
                                    className="icon"
                                    onClick={() =>
                                      onRemoveSubList(holder, idx, idxx)
                                    }
                                  >
                                    <DynamicIcon iname="close" />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          padding: "14px",
                          borderRadius: "8px",
                          backgroundColor: "#5CA9FB",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#ffffff",
                        }}
                        className="icon"
                        onClick={() => onEditList(holder, idx)}
                      >
                        <EditIcon />
                        Edit
                      </div>
                      <div
                        style={{
                          padding: "14px",
                          borderRadius: "8px",
                          backgroundColor: "#5CA9FB",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#ffffff",
                        }}
                        className="icon"
                        onClick={() =>
                          setActiveSub({
                            open: true,
                            holder,
                            idx,
                            title: "Sub Paragraph",
                          })
                        }
                      >
                        <CirclePlus />
                        Sub
                      </div>
                      <div
                        style={{
                          padding: "14px",
                          borderRadius: "8px",
                          backgroundColor: "#ff0202ff",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#ffffff",
                        }}
                        className="icon"
                        onClick={() => onRemoveList(holder, idx)}
                      >
                        <Trash2 />
                        Del
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      );
    } else if (
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-DEPONENT]" ||
      holder.dataType == "UPLOADED MEDIA[SEAL-COMISSIONER]" ||
      holder.dataType == "UPLOADED MEDIA[STAMP-COMISSIONER]" ||
      holder.dataType == "UPLOADED MEDIA[PASSPORT]" ||
      holder.dataType == "UPLOADED MEDIA[SEAL-DEPONENT]" ||
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-COMISSIONER]" ||
      (holder.dataType == "UPLOADED MEDIA[IMAGE]" &&
        holder.holder != "[QR-CODE]" &&
        holder.holder != "[CASHIER_SEAL]" &&
        holder.holder != "[CASHIER_STAMP]")
    ) {
      const ss = checkMedia(holder);
      const label =
        profile.role.name === "Affidavit User"
          ? ""
          : profile.role.name === "Legal Counsel"
            ? "Deponent"
            : "CFO";
      return (
        <div className="append">
          <div className="instrument-img">
            <img
              src={
                holdervalues[holder.id] == null
                  ? ss.status
                    ? ss.imgPath
                    : Seal
                  : holdervalues[holder.id]?.value
              }
              alt="Instrument"
              style={{ width: 100 }}
            />
            <p>{`${label} ${ss.type}`}</p>
          </div>
          <div className="buttongrp">
            {ss.status && (
              <div>
                <button
                  className={"apply_btn"}
                  onClick={() => onAppendStoreImg(holder, ss.imgPath)}
                  type="button"
                >
                  Apply
                </button>
              </div>
            )}
            <div className="append-create" onClick={() => onAppending(holder)}>
              <label htmlFor="append-seal">
                {ss.status ? `Choose Another ${ss.type}` : holder.name}
              </label>
            </div>
          </div>
        </div>
      );
    } else if (holder.holder == "[QR-CODE]") {
      var hv = { ...holdervalues };
      var row = hv[holder.id];

      if (hv[holder.id] == null) {
        // var searchlink =
        //   item.type == "affidavit"
        //     ? `${Constants.baseurl}/search/${affidavit_search_prefix}/${
        //         currectdoc?.upline?.id
        //       }/${retrieveDocYear()}}`
        //     : `${Constants.baseurl}/search/${item.caseNumber}/HC/${currectdoc?.upline?.id}}`;
        // var urlimg = Constants.QrCodelink(currectdoc?.upline?.docRef);
        var searchlink = `${Constants.baseurl}/search/${currectdoc?.upline?.docRef}`;
        var urlimg = Constants.QrCodelink(searchlink);
        onAppendStoreImg(holder, urlimg);
      }
    } else if (holder.holder == "[CASHIER_SEAL]" && isPaid) {
      var hv = { ...holdervalues };
      var row = hv[holder.id];
      if (hv[holder.id] == null) {
        var cashierlink = `${Constants.rooturl}/resources/special/cashier_seal_${currectdoc?.upline?.id}.png`;
        var urlimg = cashierlink;
        onAppendStoreImg(holder, urlimg);
      }
    } else if (holder.holder == "[CASHIER_STAMP]" && isPaid) {
      var hv = { ...holdervalues };
      var row = hv[holder.id];
      if (hv[holder.id] == null) {
        var cashierlink = `${Constants.rooturl}/resources/special/cashier_stamp.png`;
        var urlimg = cashierlink;
        onAppendStoreImg(holder, urlimg);
      }
    } else {
      const isCashierStampSeal =
        holder.name === "Append Cashier Seal" ||
        holder.name === "Append Cashier Samp";
      return (
        !isCashierStampSeal && (
          <div>
            <div className="input-create">
              <label htmlFor="doc-title">{holder.name} </label>
              <input
                type="text"
                value={onGetValue(holder)}
                onChange={(e) => onDirectText(e, holder, ind)}
                placeholder={holder.hint}
                required
              />
            </div>
          </div>
        )
      );
    }
  };

  const onAppendStoreImg = (holder, imgpath) => {
    if (
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-DEPONENT]" ||
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-COMISSIONER]"
    ) {
      if (
        (permissionList.has(currectdoc?.upline?.gazetteItemId) ||
          item.type == "affidavit") &&
        !currectdoc?.upline?.allowSign
      ) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Append ",
          subtitle:
            "Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call",
          onOk,
        });
        return;
      }
    }

    var hv = { ...holdervalues };
    var row = hv[holder.id];
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value: imgpath, type: "media" };
    } else {
      hv[holder.id] = { ...row, value: imgpath };
    }

    setHolderValues(hv);
    replaceTemplate(hv);
  };

  const checkMedia = (hh) => {
    var holdertype = hh.dataType;
    if (hh.holder == "[CFO_SEAL]" || hh.holder == "[DEPONENT-SEAL]") {
      return { status: seal != "", imgPath: seal, type: "Seal" };
    } else if (hh.holder == "[CFO_INITIAL]") {
      return { status: initial != "", imgPath: initial, type: "Initial" };
    } else if (hh.holder == "[CFO_STAMP]") {
      return { status: stamp != "", imgPath: stamp, type: "Stamp" };
    } else if (
      hh.holder == "[SIGNATURE-DEPONENT]" ||
      hh.holder == "[LEGAL-COUNSEL-SIGNATURE]"
    ) {
      return { status: sign != "", imgPath: sign, type: "Signature" };
    } else if (hh.holder == "[PASSPORT]") {
      return { status: passport != "", imgPath: passport, type: "Passport" };
    } else {
      return { status: false };
    }
  };

  const onDirectText = (e, holder) => {
    var str = Constants.ConvertText(e.target.value);
    const value = str;
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value: value, type: "single" };
    } else {
      hv[holder.id] = { ...row, value: value };
    }

    setHolderValues(hv);
    replaceTemplate(hv);
    setIsSaved(false);
  };

  const onTimeStamp = (holder) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    const currentdate = new Date();
    var tstamp = moment(currentdate).format("DD/MM/YYYY hh:mm a");
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value: tstamp, type: "single" };
    } else {
      hv[holder.id] = { ...row, value: tstamp };
    }

    setHolderValues(hv);
    replaceTemplate(hv);
    setIsSaved(false);
  };

  const onDirectTextMultiple = (e, holder) => {
    var hv = { ...holdervalues };
    const value = Constants.ConvertText(e.target.value?.toUpperCase());
    var row = hv[holder.id];
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value, type: "list" };
    } else {
      hv[holder.id] = { ...row, value };
    }

    setHolderValues(hv);
    setIsSaved(false);
  };

  const onDirectAreaMultiple = (e, holder) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    var value = Constants.ConvertText(e.target.value);
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value, type: "paragraph" };
    } else {
      hv[holder.id] = { ...row, value };
    }

    setHolderValues(hv);
    setIsSaved(false);
  };

  const onDirectDate = (e, holder, index) => {};

  const onGetValue = (holder) => {
    return holdervalues[holder.id]?.value;
  };

  const replaceTemplate = (obj) => {
    if (currectdoc.template == null) return;

    var htmlstr = Constants.b64decode(currectdoc.template.html);
    var rhtml = htmlstr;

    // Helper function to create media element with inline styles
    const createMediaElement = (holder, value) => {
      const mediaConfig = {
        "[QR-CODE]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: center; float: right; margin: 0 0 10px 10px; clear: right;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
        "[PASSPORT]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: center; float: left; margin: 0 10px 10px 0; clear: left;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
        "[CFO_INITIAL]": {
          wrapperStyle:
            "display: inline-flex; align-items: center; vertical-align: middle; margin: 0 5px;",
          imgStyle:
            "display: inline-block; vertical-align: middle; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent; width: 80px;",
          size: "80px",
          inline: true,
        },
        "[CASHIER_SEAL]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: center; float: left; clear: none; margin: 10px 10px 10px 0; width: auto;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
        "[CASHIER_STAMP]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: center; float: right; clear: none; margin: 10px 0 10px 10px; width: auto;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
        "[CFO_SEAL]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: center; text-align: center;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
        "[DEPONENT-SEAL]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: center; text-align: center;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
        "[CFO_STAMP]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: center; text-align: center;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
        "[SIGNATURE-DEPONENT]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: flex-end; text-align: right;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
        "[LEGAL-COUNSEL-SIGNATURE]": {
          wrapperStyle:
            "margin: 10px 0; display: flex; align-items: center; justify-content: flex-start; text-align: left;",
          imgStyle:
            "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
          size: "100px",
        },
      };

      const config = mediaConfig[holder] || {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: center;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain;",
        size: "100px",
      };

      if (config.inline) {
        return `<span style="${config.wrapperStyle}"><img src="${value}" style="${config.imgStyle}" width="${config.size}" alt="Media" /></span>`;
      }

      return `<div style="${config.wrapperStyle}"><img src="${value}" style="${config.imgStyle}" width="${config.size}" alt="Media" /></div>`;
    };

    for (const ho of Object.values(obj)) {
      if (ho.type == "single") {
        const escapedValue = ho.value || "";
        rhtml = Constants.ReplaceAll(rhtml, ho.holder, escapedValue);
        rhtml = rhtml.replace(/(?:\r\n|\r|\n)/g, "<br>");
      } else if (ho.type == "media") {
        if (ho.holder === "[QR-CODE]" && !isCurrentDocCommissioned) {
          rhtml = Constants.ReplaceAll(rhtml, ho.holder, "");
          continue;
        }
        let mediaHtml = createMediaElement(ho.holder, ho.value);

        // Add clearfix after cashier stamp to force next content to new line
        if (ho.holder === "[CASHIER_STAMP]") {
          mediaHtml += '<div style="clear: both;"></div>';
        }

        rhtml = Constants.ReplaceAll(rhtml, ho.holder, mediaHtml);
      } else if (ho.type == "list") {
        if (ho.listobj != null && ho.listobj.length > 0) {
          let listHtml = '<div style="margin: 16px 0; padding: 0 16px;">';
          listHtml +=
            '<ol style="list-style-type: decimal; margin: 0; padding-left: 25px;">';

          for (const li of ho.listobj) {
            listHtml += `<li style="margin: 8px 0; padding-left: 5px; line-height: 1.6; color: #282828; font-size: 14px;">${li}</li>`;
          }

          listHtml += "</ol></div>";
          rhtml = Constants.ReplaceAll(rhtml, ho.holder, listHtml);
        }
      } else if (ho.type == "paragraph") {
        if (ho.listobj != null && ho.listobj.length > 0) {
          let paraHtml = '<div style="margin: 16px 0; padding: 0 16px;">';

          ho.listobj.forEach((li, idx) => {
            paraHtml += `<div style="margin: 12px 0;">`;
            paraHtml += `<div style="font-size: 14px; line-height: 1.6; color: #282828; margin-bottom: 8px; font-weight: 500;">${
              idx + 1
            }. ${li.value}</div>`;

            if (li.subs != null && li.subs.length > 0) {
              paraHtml +=
                '<div style="margin: 8px 0 8px 25px; padding-left: 10px; border-left: 2px solid #e5e7eb;">';

              li.subs.forEach((sub, subIdx) => {
                const alphaLabel = Constants.getAlphaByNum(subIdx + 1);
                paraHtml += `<div style="font-size: 14px; line-height: 1.6; color: #404040; margin: 6px 0; padding-left: 5px;">${alphaLabel}). ${sub}</div>`;
              });

              paraHtml += "</div>";
            }

            paraHtml += "</div>";
          });

          paraHtml += "</div>";
          rhtml = Constants.ReplaceAll(rhtml, ho.holder, paraHtml);
        }
      }
    }

    setHtml(rhtml);
  };
  const onFinalProcess = async () => {
    setIsDialog(false);
    try {
      const theurl = `${Constants.apiUrl}/filing/saveTemplateData/${currectdoc.upline.id}`;
      setIsLoading(true);
      var strjson = btoa(JSON.stringify(holdervalues));
      var base64 = Constants.b64encode(html);
      const data = {
        docuplineId: currectdoc.upline.id,
        htmlstr: base64,
        jsonstr: strjson,
        doctype,
        Userid: profile.username,
        isFinal: true,
      };
      const resp = await fetch(theurl, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await resp.json();
      setIsLoading(false);

      if (responseData.code == 0) {
        if (responseData.incompleted == 0) {
          setAlert({
            ...alert,
            title: "Process Document",
            open: true,
            subtitle: onfinalMsg(),
            onOk: onIsCompleted,
          });
        } else {
          setAlert({
            ...alert,
            title: "Process Document",
            open: true,
            subtitle: `Processed Successfully. Document remain to be processed ${responseData.incompleted}`,
            onOk,
          });
        }

        setIsSaved(true);
      } else if (responseData.code == -10) {
        setIsExpired(true);
      } else {
        setAlert({
          open: true,
          title: "Template",
          subtitle: responseData.status,
          onOk,
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onfinalMsg = () => {
    if (item.type == "affidavit") {
      return finalmsgaffidavit;
    } else if (doctype == "sheriff") {
      return finalmssheriff;
    } else if (doctype == "settlement") {
      return finalsettlement;
    } else {
      return finalmsgcase;
    }
  };

  const onSaveMsg = () => {
    if (
      permissionList.has(currectdoc?.upline?.gazetteItemId) ||
      item.type == "affidavit"
    ) {
      return needpermission;
    } else if (doctype == "sheriff") {
      return finalmssheriff;
    } else if (doctype == "settlement") {
      return finalsettlement;
    } else {
      return needpermission;
    }
  };

  const onSaveDraft = async (onProcess) => {
    setIsDialog(false);

    try {
      const theurl = `${Constants.apiUrl}/filing/saveTemplateData/${currectdoc.upline.id}`;
      setIsLoading(true);
      var stfy = JSON.stringify(holdervalues);
      var strjson = Constants.b64encode(stfy);
      var base64 = Constants.b64encode(html);
      const data = {
        docuplineId: currectdoc.upline.id,
        jsonstr: strjson,
        htmlstr: base64,
        doctype,
        Userid: profile.username,
        isFinal: false,
      };
      const resp = await fetch(theurl, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const responseData = await resp.json();
      setIsLoading(false);

      if (responseData.code == 0) {
        if (onProcess) {
          onProcess();
        } else {
          setAlert({
            open: true,
            title: "Document",
            subtitle: onSaveMsg(),
            onOk: onOk_Save,
          });
        }
        setIsSaved(true);
      } else if (responseData.code == -10) {
        setIsExpired(true);
      } else {
        setAlert({
          open: true,
          title: "Document1",
          subtitle: responseData.status,
          onOk,
        });
      }

      setIsSaved(true);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onProcessAction = (onProcess) => {
    const arrMain = Object.values(holdervalues);
    if (isLegal) {
      onProcess ? onSaveDraft(onProcess) : onSaveDraft();
    } else {
      onFinalProcess();
    }
  };

  const cancelUpload = () => {
    setUpload({ open: false });
  };

  const onIsCompleted = () => {
    setAlert({ ...alert, open: false });
    if (item.type == "affidavit") {
      navigate("/affidavits");
    } else if (doctype == "sheriff") {
      navigate("/cfo-e-swearing-sheriff");
    } else {
      navigate("/cfo-e-swearing");
    }
  };

  useEffect(() => {
    replaceTemplate(holdervalues);
  }, [html, refresh, holdervalues]);

  const onAllowSign = (e) => {
    onAllow(true, "sign");
  };

  const onAllowSeal = (e) => {
    onAllow(true, "seal");
  };

  const onAllow = (isAllow, instType) => {
    const url = `${Constants.apiUrl}/filing/allowinstrument/${currectdoc?.upline?.id}`;
    var ll = {
      uplineId: currectdoc?.upline?.id,
      isAllow,
      instType,
      cfoUserid: profile.username,
    };
    setIsLoading(true);

    fetch(url, {
      method: "POST",
      body: JSON.stringify(ll),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          if (instType == "seal") {
            setCurrentDoc({
              ...currectdoc,
              upline: { ...currectdoc.upline, allowSeal: isAllow },
            });
          } else if (instType == "sign") {
            setCurrentDoc({
              ...currectdoc,
              upline: { ...currectdoc.upline, allowSign: isAllow },
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const retrieveDocYear = () => {
    return currectdoc?.upline.uploadDate == null
      ? moment(new Date()).format("YYYY")
      : moment(currectdoc?.upline.uploadDate).format("YYYY");
  };

  const hasTextareaField = () => {
    return holders.some(
      (holder) => holder.dataType === "TEXT[MULTIPLE-TEXTAREA]",
    );
  };

  const hasTextareaContent = () => {
    return Object.values(holdervalues).some(
      (hv) =>
        hv.dataType === "TEXT[MULTIPLE-TEXTAREA]" &&
        hv.listobj &&
        hv.listobj.length > 0,
    );
  };

  const hasPassportField = () => {
    // Check if template has passport field
    return holders.some((holder) => holder.holder === "[PASSPORT]");
  };

  const isPassportApplied = () => {
    return Object.values(holdervalues).some(
      (hv) => hv.holder === "[PASSPORT]" && hv.value && hv.value.trim() !== "",
    );
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Reset error states
    setIsTextareaFilled(false);
    setIsCFOPassportApplied(false);

    // Validate textarea content only if template has textarea field
    if (hasTextareaField() && !hasTextareaContent()) {
      setIsTextareaFilled(true);
      return;
    }

   /*  if(isLegal && !isPaid){

    }else{
      
    } */
    // Validate passport only if template has passport field
    if (hasPassportField() && !isPassportApplied()) {
      setIsCFOPassportApplied(true);
      return;
    }

    // All validations passed, proceed with payment
    onProcessAction(() => setIsPay(true));
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="body" style={{ width: "100%" }}>
        <div className="document">
          <div className="doc-side">
            <div
              className="wrapper"
              style={{
                maxWidth: 750,
                width: "100%",
                backgroundColor: "white",
                color: "black",
                padding: 0,
                position: "relative",
                overflow: "auto",
              }}
            >
              <div
                className="htmlwrap"
                dangerouslySetInnerHTML={{ __html: html }}
              ></div>
            </div>
          </div>

          <div className="action_wrapper">
            {!isLegal && (
              <div className="cfo-create-submit-btn cfo-create-submit-action-btn">
                <JisButton variant="primary" type="button" onClick={onSchedule}>
                  {scheduleButtonText}
                </JisButton>
                <JisButton variant="outline" type="button">
                  Rework Document
                </JisButton>
              </div>
            )}
            <div className="actions">
              <div className="create-case cfo-create-case">
                <div className="body">
                  <div className="top-nav">
                    <div
                      className={
                        "left-top " +
                        (isCfo ? "cfo-prepare-affidavit-section" : "")
                      }
                    >
                      {isCfo ? (
                        <div>
                          <p className="title">Affidavit Actions</p>
                          <p className="description">
                            Digitally signed and authorized seals, signatures,
                            and time stamps
                          </p>
                        </div>
                      ) : (
                        <p>
                          Please fill in the inputs and append seal and
                          signature{" "}
                        </p>
                      )}

                      {!isLegal &&
                        (permissionList.has(
                          currectdoc?.upline?.gazetteItemId,
                        ) ||
                          item.type == "affidavit") && (
                          <div className="check-sign">
                            <div className="cfo_input">
                              <input
                                type="checkbox"
                                id="check-cfo"
                                checked={currectdoc?.upline?.allowSign}
                                disabled={currectdoc?.upline?.allowSign}
                                onChange={(e) => onAllowSign(e)}
                              />
                              <label htmlFor="check-cfo">
                                Allow to Append Signature
                              </label>
                            </div>
                          </div>
                        )}

                      {(permissionList.has(currectdoc?.upline?.gazetteItemId) ||
                        item.type == "affidavit") && (
                        <div>
                          {currectdoc?.upline?.allowSign ? (
                            <span
                              style={{ color: green[500], fontWeight: "bold" }}
                            >
                              permission granted for you to append your
                              signature/seal{" "}
                            </span>
                          ) : (
                            <span
                              style={{ color: red[500], fontWeight: "bold" }}
                            >
                              Permission required for item{" "}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    <p className="nav-status"></p>
                  </div>

                  <form onSubmit={handleFormSubmit}>
                    <div className="form cfo-prepare-affidavit-form ">
                      <div className="left-side">
                        {holders.length > 0 &&
                          holders?.map((ho, idx) => {
                            return (
                              ((isLegal &&
                                !Constants.CFO_Placeholders.has(ho.id)) ||
                                (!isLegal &&
                                  ho.dataType &&
                                  Constants.CFO_Placeholders.has(ho.id))) &&
                              ho.dataType !== "TEXT[MULTIPLE-TEXTAREA]" &&
                              returnTag(ho, idx)
                            );
                          })}
                      </div>
                    </div>

                    {/* Add Paragraph Section */}
                    <div className="paragraph-section">
                      {holders.length > 0 &&
                        holders
                          ?.filter(
                            (ho) => ho.dataType === "TEXT[MULTIPLE-TEXTAREA]",
                          )
                          ?.map((ho, idx) => {
                            return (
                              ((isLegal &&
                                !Constants.CFO_Placeholders.has(ho.id)) ||
                                (!isLegal &&
                                  ho.dataType &&
                                  Constants.CFO_Placeholders.has(ho.id))) &&
                              returnTag(ho, idx)
                            );
                          })}
                    </div>

                    <div className="down">
                      {hasTextareaField() && isTextareaFilled && (
                        <p style={{ color: "red", marginTop: 8 }}>
                          Please add at least one paragraph before saving.
                        </p>
                      )}
                      {hasPassportField() && isCFOPassportApplied && (
                        <p style={{ color: "red", marginTop: 8 }}>
                          Please upload and apply the CFO Passport before
                          saving.
                        </p>
                      )}
                      <div className="cfo-create-submit-btn cfo-create-submit-group-btn">
                        <JisButton
                          type="button"
                          variant={!isPaid ? "outline" : "primary"}
                          onClick={() => setIsDialog(true)}
                        >
                          {isLegal
                            ? !isPaid
                              ? "Save to Draft"
                              : "Update Affidavit Document"
                            : "Process Document"}
                        </JisButton>
                        {!isPaid && (
                          <JisButton type="submit">Make Payment</JisButton>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="down">
          {!currectdoc.upline.isTemplate && (
            <Link to={`/upload/documents/${item.caseFeeId}`}>
              <span>Select Template</span>{" "}
            </Link>
          )}

          {isThirdOpt && (
            <button onClick={() => confirmCaseDoc()}>Confirm Document</button>
          )}
        </div>
      </div>
      {cfoWarn && (
        <div className={"warning show"}>
          <div className="container">
            <div className="icon" onClick={() => setCfoWarn(false)}>
              <DynamicIcon iname="close" />
            </div>
            <div className="body">
              <h3>Appending Signature</h3>
              <p>
                You are not allowed to upload your signature yet. Please wait
                for the Chief for Oath (CFO) authorizes you to upload your
                signature. In the mean time, you can upload your seal and
                passport{" "}
              </p>
              <button onClick={() => setCfoWarn(false)}>Ok</button>
            </div>
          </div>
        </div>
      )}

      <BackLoader open={isLoading} />
      {alert.open && <JisAlert {...alert} />}
      <JisPrompt
        open={isDialog}
        onOk={() => onProcessAction()}
        onCancel={() => setIsDialog(false)}
      >
        <p
          style={{
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {profile.role == "LegalCounsel" || profile.role == "Customer" ? (
            <strong>
              Are you sure you want to save this template ? You will not be able
              to amend after the Commissioner for Oaths has worked on it
            </strong>
          ) : (
            <strong>Are you sure you want to save this template?</strong>
          )}
        </p>
      </JisPrompt>

      {upload.open && (
        <JisDialogForm title="Upload" minWidth="40%" onClose={cancelUpload}>
          <div>
            <div className="upload-wrap">
              <h3>{upload.title}</h3>
              <div className="upload-file-btn">
                <label htmlFor="upload-input" className="upload-input-label">
                  <input
                    type="file"
                    id="upload-input"
                    accept="image/*"
                    onChange={previewImage}
                    placeholder="uploading image"
                  />
                  upload image
                </label>
                {upload.isImage && (
                  <img
                    src={upload.data}
                    style={{ height: 100 }}
                    alt="Uploaded Media"
                  />
                )}
              </div>

              <p className="warn">Maximum File Upload: 1mb</p>
              <div className="schedule_btn_wrapper">
                <button variant="default" onClick={() => cancelUpload()}>
                  Cancel
                </button>
                <button icon="check_circle" onClick={onSaveInst}>
                  Upload
                </button>
              </div>
            </div>
          </div>
        </JisDialogForm>
      )}

      {activeSub.open && (
        <JisDialog title={activeSub.title}>
          <div className="upload-wrap">
            <textarea
              value={activeSub.value}
              style={{ width: "100%", height: 100, padding: 16 }}
              onChange={(e) =>
                setActiveSub({
                  ...activeSub,
                  value: Constants.ConvertText(e.target.value),
                })
              }
            ></textarea>

            <button icon="check_circle" onClick={onAddSubPara}>
              Add Sub Paragraph
            </button>
            <button
              className="red"
              onClick={() => setActiveSub({ open: false })}
            >
              Cancel
            </button>
          </div>
        </JisDialog>
      )}

      <JisInternalPay
        isPay={isPay}
        docuploadid={currectdoc?.upline?.docUploadId}
        name={profile?.firstName}
        email={profile?.primaryEmail}
        phone={profile?.primaryContactNumber}
        amount={amount}
        externalAmount={amount-sealAmt}
        internalAmount={sealAmt}
        onCancel={() => setIsPay(false)}
        ref={ref}
      />
    </div>
  );
}

export default LegalCounselorJisPrepareTemplate;
